import { createStyles } from 'antd-style';
import React from 'react';

const useStyles = createStyles(({ token, css }) => ({
  footer: css`
    padding: 16px 24px;
    text-align: center;
    color: ${token.colorTextDescription};
    font-size: ${token.fontSizeSM}px;
    line-height: ${token.lineHeight};
    background: transparent;
  `,
  copyright: css`
    margin-bottom: 6px;
  `,
  meta: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px 8px;
  `,
  link: css`
    color: ${token.colorTextDescription};
    text-decoration: none;
    transition: color ${token.motionDurationMid};

    &:hover {
      color: ${token.colorText};
    }
  `,
  sep: css`
    color: ${token.colorTextQuaternary};
    user-select: none;
  `,
}));

const Footer: React.FC = () => {
  const { styles } = useStyles();
  const year = new Date().getFullYear();

  return (
    <div className={styles.footer}>
      <div className={styles.copyright}>
        Copyright © {year}{' '}
        <a
          className={styles.link}
          href="https://deroad.top"
          target="_blank"
          rel="noopener noreferrer"
        >
          Deroad（德路）
        </a>
      </div>
      <div className={styles.meta}>
        <span>大数据和 AI 支持</span>
        <span className={styles.sep}>·</span>
        <a
          className={styles.link}
          href="https://www.yun-nao.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          云脑超算
        </a>
      </div>
    </div>
  );
};

export default Footer;
